<router-outlet></router-outlet>
<app-login-modal *ngIf="!sessionService.loggedIn() && !maintenanceModeOn"></app-login-modal>